/* eslint-disable max-len */
import React, { Component } from 'react';
import { connect } from 'react-redux';

import Results from '../components/Results';
import IntroBackground from '../assets/results/intro_background.svg';
import { speak } from '../actions';

class ResultsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  componentDidMount() {
  }

  scrollToDiv = (id) => {
    const { offsetTop } = document.getElementById(id);
    document.getElementById('scroll-container').scroll(0, offsetTop - 60);
  }

  renderIntroBoxes = () => {
    const survey = this.props.surveys[this.props.match.params.surveyid];
    return (
      <div>
        <div className="box intro-box">
          <div className="intro-box-text">
            <h1 onClick={this.props.speak} className={`color ${this.props.speechEnabled && 'bolded'}`}>Take a look at your results, {this.props.username}!</h1>
            <p onClick={this.props.speak} className={`color result-text ${this.props.speechEnabled && 'bolded'}`}>Thank you for taking the <b>“{survey.name}”</b> survey. Here, you can learn about your brain, strength & weaknesses and find useful resources.</p>
          </div>
          <img src={IntroBackground} alt="intro" />
        </div>
        <div className="summary-boxes-container">
          <div className="box summary-box">
            <div className="summary-header">
              <svg width="23.76" height="21" viewBox="0 0 43 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15.5065 0.306641C13.2775 0.306641 11.4286 1.79595 10.8993 3.80833C10.8397 3.80833 10.7949 3.7938 10.7353 3.7938C8.10365 3.7938 5.96405 5.87882 5.96405 8.44334C5.96405 8.79205 6.00878 9.1335 6.09079 9.46042C3.91391 10.3322 2.38562 12.41 2.38562 14.8365C2.38562 15.7518 2.62418 16.6018 3.00439 17.3719C1.21518 18.3745 0 20.2343 0 22.392C0 24.8112 1.52083 26.8889 3.6828 27.7607C3.61571 28.0949 3.57843 28.4364 3.57843 28.7851C3.57843 31.6765 5.97896 34.0158 8.94608 34.0158C9.25173 34.0158 9.54994 33.9795 9.84068 33.9286C10.5564 35.9991 12.5394 37.503 14.9101 37.503C17.8772 37.503 20.2778 35.1637 20.2778 32.2722V4.95618C20.2778 2.39167 18.1382 0.306641 15.5065 0.306641ZM42.9412 22.392C42.9412 20.2343 41.726 18.3745 39.9368 17.3719C40.3244 16.6018 40.5555 15.7518 40.5555 14.8365C40.5555 12.41 39.0273 10.3322 36.8504 9.46042C36.9249 9.1335 36.9771 8.79205 36.9771 8.44334C36.9771 5.87882 34.8375 3.7938 32.2059 3.7938C32.1462 3.7938 32.094 3.80833 32.0419 3.80833C31.5126 1.79595 29.6637 0.306641 27.4346 0.306641C24.803 0.306641 22.6634 2.3844 22.6634 4.95618V32.2722C22.6634 35.1637 25.0639 37.503 28.031 37.503C30.4017 37.503 32.3848 35.9991 33.1005 33.9286C33.3912 33.9795 33.6894 34.0158 33.9951 34.0158C36.9622 34.0158 39.3627 31.6765 39.3627 28.7851C39.3627 28.4364 39.3255 28.0949 39.2584 27.7607C41.4203 26.8889 42.9412 24.8112 42.9412 22.392Z" fill="black" />
              </svg>
              <p onClick={this.props.speak} className={`color ${this.props.speechEnabled && 'bolded'}`}>YOUR BRAIN: EXPLAINED</p>
            </div>
            <p onClick={this.props.speak} className={`color result-text summary-text ${this.props.speechEnabled && 'bolded'}`}>{survey.dashboardDescription}</p>
            <button
              className="summary-box-button"
              type="button"
              onClick={() => this.scrollToDiv('ybe')}
            > Go to section
            </button>
          </div>
          <div className="box summary-box">
            <div className="summary-header" style={{ backgroundColor: '#99CDF4' }}>
              <svg width="23" height="23" viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13.875 27C17.1806 27 20.1937 25.7625 22.5056 23.7394L25.0125 28.9894C25.0125 28.9894 25.5281 29.4094 26.2369 30.1069C26.9625 30.7875 27.9169 31.7081 28.8319 32.67L31.3781 35.28L32.5106 36.4912L36.4875 32.5144L35.2762 31.3819L32.6662 28.8356C31.7881 27.9944 30.9334 27.1291 30.1031 26.2406C29.4056 25.5319 28.9856 25.0162 28.9856 25.0162L23.7356 22.5094C25.8383 20.1244 26.9989 17.0545 27 13.875C27 6.63937 21.1106 0.75 13.875 0.75C6.63938 0.75 0.75 6.63937 0.75 13.875C0.75 21.1106 6.63938 27 13.875 27Z" fill="black" />
              </svg>
              <p onClick={this.props.speak} className={`color ${this.props.speechEnabled && 'bolded'}`}>INSIGHTS</p>
            </div>
            <p onClick={this.props.speak} className={`color result-text summary-text ${this.props.speechEnabled && 'bolded'}`}>Here you can find a summary of the areas that you feel are going well and where we can help you strengthen your peformance.</p>
            <button
              className="summary-box-button"
              type="button"
              onClick={() => this.scrollToDiv('insights')}
            > Go to section
            </button>
          </div>
          <div className="box summary-box">
            <div className="summary-header" style={{ backgroundColor: '#D9EBF9' }}>
              <svg width="24.75" height="22" viewBox="0 0 45 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M43.4831 30.9141L33.3644 21.7656C31.3683 19.9609 28.3871 19.6094 25.9849 20.6797L16.7735 12.3516V7.5L5.71285 0L0.182543 5L8.478 15H13.8441L23.0555 23.3281C21.8803 25.5 22.2605 28.1953 24.2566 30L34.3754 39.1484C35.637 40.2891 37.6763 40.2891 38.9292 39.1484L43.4831 35.0312C44.736 33.8906 44.736 32.0469 43.4831 30.9141ZM28.8451 17.5781C31.2905 17.5781 33.589 18.4375 35.3172 20L36.9936 21.5156C38.3589 20.9766 39.6551 20.2266 40.7784 19.2109C43.9843 16.3125 45.0731 12.2344 44.0534 8.53125C43.8633 7.82812 42.8869 7.58594 42.3165 8.10156L35.8876 13.9141L30.0203 13.0312L29.0438 7.72656L35.4728 1.91406C36.0431 1.39844 35.7666 0.515625 34.9802 0.335938C30.8844 -0.578125 26.3737 0.40625 23.1765 3.29688C20.7138 5.52344 19.5559 8.46094 19.6164 11.3906L26.7107 17.8047C27.4106 17.6562 28.1365 17.5781 28.8451 17.5781ZM19.867 23.9844L14.9675 19.5547L1.79843 31.4688C-0.361846 33.4219 -0.361846 36.5859 1.79843 38.5391C3.9587 40.4922 7.45835 40.4922 9.61862 38.5391L20.299 28.8828C19.6423 27.3281 19.4436 25.6328 19.867 23.9844ZM5.71285 36.875C4.57222 36.875 3.63898 36.0312 3.63898 35C3.63898 33.9609 4.56358 33.125 5.71285 33.125C6.86211 33.125 7.78671 33.9609 7.78671 35C7.78671 36.0312 6.86211 36.875 5.71285 36.875Z" fill="black" />
              </svg>
              <p onClick={this.props.speak} className={`color ${this.props.speechEnabled && 'bolded'}`}>TOOLS</p>
            </div>
            <p onClick={this.props.speak} className={`color result-text summary-text ${this.props.speechEnabled && 'bolded'}`}>We&apos;ve compiled a personalized set of tools for you and added them to your Toolkit. They&apos;re organized in buckets or you can view them all at once.</p>
            <button
              className="summary-box-button"
              type="button"
              onClick={() => this.scrollToDiv('tools')}
            > Go to section
            </button>
          </div>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className="result-container" id="scroll-container">
        <div className="result-subcontainer">
          {this.renderIntroBoxes()}
          <Results
            survey={this.props.surveys[this.props.match.params.surveyid]}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => (
  {
    surveys: state.survey.surveys,
    username: state.user.firstName,
    speechEnabled: state.speech.enabled,
  }
);

export default connect(mapStateToProps, { speak })(ResultsPage);
